import { fetchJson } from './apiClient';

export type AdminUserLite = {
  id: string;
  name: string;
  email: string;
  username?: string;
  handle?: string;
  company?: string;
  position?: string;
  isActive?: boolean;
  isManager?: boolean;
};

export async function searchUsers(q: string, limit = 10): Promise<AdminUserLite[]> {
  const params = new URLSearchParams({ q, limit: String(limit) });
  return fetchJson(`/api/admin/search-users?${params.toString()}`);
}

export async function promoteToManager(userId: string, role: 'basicadmin' | 'superadmin') {
  // We need an email and name to create Manager; resolve first via find-user
  const params = new URLSearchParams({ q: userId });
  const found: any = await fetchJson(`/api/admin/find-user?${params.toString()}`);
  const user = found && found.user;
  if (!user) throw new Error('User not found');
  const payload = { name: user.name || user.username || 'Admin', email: user.email, role };
  // Use existing managers API to create
  const res = await fetchJson(`/api/admin/managers`, { method: 'POST', body: JSON.stringify(payload) });
  return res;
}

export async function findUserByQuery(q: string): Promise<AdminUserLite | null> {
  const params = new URLSearchParams({ q });
  const found: any = await fetchJson(`/api/admin/find-user?${params.toString()}`).catch(() => null);
  const u = found && (found.user || found);
  if (!u) return null;
  return {
    id: String(u.id || u._id || u.username || ''),
    name: u.name || '',
    email: u.email || '',
    username: u.username || u.customPath || undefined,
  };
}

export async function deleteUserByAdmin(idOrUsername: string): Promise<void> {
  const key = encodeURIComponent(String(idOrUsername));
  await fetchJson(`/api/admin/users/${key}`, { method: 'DELETE' });
}

export default { searchUsers, promoteToManager, findUserByQuery, deleteUserByAdmin };
